module.exports = __webpack_public_path__ + "img/2x.541c959.jpg";